import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, CircularProgress, Typography, makeStyles } from '@material-ui/core';

// Estilos customizados para a Passarela 44
const useStyles = makeStyles((theme) => ({
    backdrop: {
        // Fica acima de qualquer outro componente ou modal
        zIndex: theme.zIndex.modal + 1,
        color: '#FFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    progress: {
        // Cor de destaque da sua marca
        color: '#E2725B',
    },
    message: {
        marginTop: theme.spacing(2),
        fontWeight: 500,
    }
}));

const LoadingOverlay = ({ open, message }) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={open}>
            <CircularProgress
                className={classes.progress}
                size={60}
                thickness={4}
            />
            {message && (
                <Typography variant="h6" className={classes.message}>
                    {message}
                </Typography>
            )}
        </Backdrop>
    );
};

// CORREÇÃO: PropTypes.bool em vez de PropTypes.boolean
LoadingOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string,
};

LoadingOverlay.defaultProps = {
    message: 'Processando...',
};

export default LoadingOverlay;